/*eslint-disable*/
/**
 * @method 数字金额中间加上逗号
 * @param {number | string} index
 * @returns string
 */
export const moneyFormat = item => {
    let num = (item || 0).toString();
    let result = '';
    while (num.length > 3) {
        result = `,${num.slice(-3)}${result}`;
        num = num.slice(0, num.length - 3);
    }
    if (num) {
        result = num + result;
    }
    return result;
};

/**
 * @method 数字转w，变成小数，向下取整
 * @param {number | string} index
 * @returns string
 */
export const numberToDecimals = (item, decimal = 2) => {
    let number = Number(item);
    number = `${item / 10000}`;
    let tmp = number.split('.');
    if (tmp[1] && tmp[1].length > decimal) {
        tmp[1] = tmp[1].slice(0, decimal);
    }
    return tmp.join('.');
};


/**
 * @method 由分转成元，后端数据是存的分，由于多个场景，前端处理，默认不要小数
 * @param {(number | string), (number | string)} item decimal
 * @returns string
 */
export const moneyToYuan = (item, decimal = 0) => {
    let money;
    let tmp;

    if (decimal === 0) {
        money = `${(+item) / 100}`;
        tmp = money.split('.');
        if (tmp && tmp[0]) {
            money = tmp[0];
        }
    } else if (typeof decimal === 'number'){
        money = `${(+item) / 100}`;
        tmp = money.split('.');
        if (tmp && tmp[1]) {
            const len = tmp[1].length;
            while(decimal > 0 && tmp[1][decimal-1] === '0' && decimal <= len) {
                decimal--;
            }
            if (decimal === 0) {
                money = tmp[0];
            } else {
                if (decimal > len) {
                    while(decimal > len) {
                        tmp[1] += '0';
                        decimal--;
                    }
                } else {
                    tmp[1] = tmp[1].slice(0, decimal);
                }
                money = tmp.join('.');
            }
        }
    }

    return money;
};

/**
 * @method 数字转换为偶数
 * @param {*} num 
 * @returns 
 */
export const makeEven = (num)=> {
    if (num % 2 != 0) {
        return num + 1;
    } 
    return num;
}

/**
 * @method toFixed向下取整
 * @param {number | string} number
 * @returns 
 */
export const toFixedFloor = (number, decimals = 3) => {
    var factor = Math.pow(10, decimals);
    return (Math.floor(+number * factor) / factor).toFixed(decimals);
}

